import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Button, Categories, LabelsName } from '../../../../../shared/model/enum';
import { SendDataService } from '../../../../../shared/services/send-data.service';
import { PartsListService } from '../../pages/parts-list/parts-list.service';
import { StingToDateService } from '../../../../../shared/services/stringToDate.service';
import { RoutePath, TraceDocument, TraceLabel } from '../../../../../shared/model/enum';
import { ActivityTabService } from '../../../../crm/companies/pages/company-info-tabs/activity-tab/activity-tab.service';
import { AddContactComponent } from '../../../../crm/contacts/pop-ups/add-contact/add-contact.component';
import { TablePaginationModel } from '../../../../../shared/components/ag-grid/ag-grid.model';
import { AgGridService } from '../../../../../shared/components/ag-grid/ag-grid.service';
import { AddEditVendorPartComponent } from '../add-edit-vendor-part/add-edit-vendor-part.component';
import { ModalPopupSize } from '../../../../../shared/model/common.model';
import { AddCompanyComponent } from '../../../../crm/companies/pop-ups/add-company/add-company.component';
import { AddEditPartComponent } from '../add-edit-part/add-edit-part.component';
import { AddEditManufacturerComponent } from '../../../../admin/look-up-tables/pop-ups/multi-level-list-popups/add-edit-manufacturer/add-edit-manufacturer.component';
import { RequirementDetails, RequirementParts,OfferDetailsModel } from '../../../../sales/requirements/popup/add-requirement/add-requirement.model';
import { CommonTabService } from 'src/app/shared/services/common-tab.service';
import { forkJoin } from 'rxjs';

const OFFER_SCORE_CONFIG = {
  label: {
    [TraceLabel.FullManufacturerLabel]: 30,
    [TraceLabel.RedactedManufacturerLabel]: 10,
    [TraceLabel.NoManufacturerLabel]: 0,
  } as Record<string, number>,

  traceDocument: {
    [TraceDocument.ManufacturerCoc]: 40,
    [TraceDocument.FranchiseCoc]: 40,
    [TraceDocument.ThirdPartyFranchise]: 10,
  } as Record<string, number>,

  traceablePart: { yes: 30, no: 0 },
  recentTestReport: { yes: 10, no: 0 },
  avlVendorBonus: 30,
  maxScore: 140,
} as const;

const TESTING_DECISION_THRESHOLDS: { minScore: number; testingId: string }[] = [
  { minScore: 110, testingId: '3' }, 
  { minScore: 60,  testingId: '2' },
  { minScore: 0,   testingId: '1' }, 
];

interface OfferScoreResult {
  score: number;
  maxScore: number;
  testingDecisionId: string;
  breakdown: {
    label: number;
    traceDocument: number;
    traceablePart: number;
    recentTestReport: number;
    avlVendor: number;
  };
}
@Component({
  selector: 'app-add-edit-offer',
  templateUrl: './add-edit-offer.component.html',
  styleUrls: ['./add-edit-offer.component.scss']
})
export class AddEditOfferComponent implements OnInit {
  paginationBaseModel = new TablePaginationModel();
  enumFilterLabel = LabelsName;
  active = 1;
  tabData = [{ id: 1, label: 'Offer Details' }, { id: 2, label: 'Part Details' }];
  enumButtonName = Button;
  title: string;
  submit: boolean = false;
  @Input() data: any = {};
  @Input() formModel: any = {};

  getAllDropdown: any = {};
  traceablelabelList  = [{ id: '1', name: 'Yes', value: true  }, { id: '2', name: 'No', value: false }];
  labelList = [
    { id: TraceLabel.FullManufacturerLabel,    name: 'Full Manufacturer Label',      status: false },
    { id: TraceLabel.RedactedManufacturerLabel, name: 'Redacted Manufacturer Label', status: false },
    { id: TraceLabel.NoManufacturerLabel,       name: 'No Manufacturer Label',       status: false },
  ];
  traceDocumentList   = [
    { id: TraceDocument.ManufacturerCoc, name: 'Manufacturer COC/Pack List', status: false },
    { id: TraceDocument.FranchiseCoc,    name: 'Franchise COC/Pack List',    status: false },
    { id: TraceDocument.ThirdPartyFranchise, name: 'Third Party/Franchise',   status: false },
  ];
  traceablePartList   = [{ id: '1', name: 'Yes', value: true }, { id: '2', name: 'No', value: false }];
  recentTestReportList = [{ id: '1', name: 'Yes', value: true }, { id: '2', name: 'No', value: false }];

  allContactList: any = {};
  dateCodeWeekList   = [];
  dateCodeYearList   = [];
  testingDecisionList = [];

  offerScoreResult: OfferScoreResult = {
    score: 0,
    maxScore: OFFER_SCORE_CONFIG.maxScore,
    testingDecisionId: '1',
    breakdown: { label: 0, traceDocument: 0, traceablePart: 0, recentTestReport: 0, avlVendor: 0 },
  };

  tooltipContent = this.buildTooltip(this.offerScoreResult.breakdown);

  disabledContact   = true;
  offerForRFQ       = false;
  selectedVendorId  = '';
  partDetails: any;
  disabledMPNfields = false;

  constructor(
    public activeModal: NgbActiveModal,
    public toaster: ToastrService,
    public renderer: Renderer2,
    public sendDataService: SendDataService,
    public partsListService: PartsListService,
    public stringToDateService: StingToDateService,
    public activityTabService: ActivityTabService,
    public modalService: NgbModal,
    public agGridService: AgGridService,
    private commonTabService: CommonTabService,
  ) {
    this.formModel.offerDetails = new OfferDetailsModel();
    this.formModel = {
      ...this.formModel,
      partsDetails: this.formModel?.partsDetails ?? {},
      traceDetails: this.formModel?.traceDetails ?? {},
      currency: this.formModel?.currency ?? '',
    };
    this.formModel.dateOfOffer = this.formModel.dateOfOffer
      ? this.stringToDateService.convertStringToDate(this.formModel.dateOfOffer)
      : this.getCurrentDateAsNgbDate();

    this.formModel.traceDetails.isTraceableLabel     = this.formModel?.traceDetails?.isTraceableLabel     ?? false;
    this.formModel.traceDetails.isRecentTraceReport = this.formModel?.traceDetails?.isRecentTraceReport ?? false;

    // Initial calculation (formModel may already have values when editing/cloning)
    this.recalculateScore();
  }

  // ── Lifecycle ───────────────────────────────────────────────────────────────
  ngOnInit(): void {
    if (this.data?.isFromSourcing) {
      this.formModel.offerDetails.mpnId = this.data?.mpnId;
      this.partDetailsGetById();
    }

    if (this.data?.viewOffer && this.data?.id) {
      forkJoin({
        partDropdowns: this.partsListService.allPartDropdownList(),
        dropdowns:     this.commonTabService.getAllDropDownList(),
      }).subscribe(({ dropdowns, partDropdowns }) => {
        this.testingDecisionList = dropdowns.response.testingDecisionList;
        if (partDropdowns?.isSuccess) {
          this.getAllDropdown  = partDropdowns.response;
          this.allContactList = partDropdowns.response.vendorContactList;
        }

        // Separate API call for offer details
        this.partsListService.getViewOfferDetailsById(this.data.id).subscribe((offerDetails) => {
          if (offerDetails?.isSuccess) {
            this.formModel = { ...this.formModel, ...offerDetails.response };
            this.formModel.offerDetails = { ...new OfferDetailsModel(), ...offerDetails.response?.offerDetails };
            this.formModel = {
              ...this.formModel,
              dateOfOffer: this.formModel.dateOfOffer ? this.stringToDateService.convertStringToDate(this.formModel.dateOfOffer) : this.getCurrentDateAsNgbDate(),
              currency: this.formModel?.currency ?? '',
              exchangeRate: this.formModel?.exchangeRate ?? '',
              convertedCost: this.formModel?.convertedCost ?? '',
            };
            if (!this.formModel.contactId) this.getContactList(this.formModel.vendorId);
            setTimeout(() => {
              this.markDropdownItemsAsActive();
              this.recalculateScore(); // ← recalculate after data is fully loaded
            });
          }
        });
      });
    } else {
      this.getAllMasterDropdownList();
      this.getDropdownData();
    }
  }

  // ── Score calculation ───────────────────────────────────────────────────────

  /**
   * Single method to (re)compute the offer score from the current formModel.
   * Call this after ANY trace field changes.
   * Stores results in `offerScoreResult` — template reads from there, never calls this directly.
   */
  recalculateScore(): void {
    const trace = this.formModel?.traceDetails ?? {};

    const breakdown = {
      label:          this.getLabelScore(trace.labelId),
      traceDocument:  this.getTraceDocScore(trace.traceDocument),
      traceablePart:  trace.isTraceableLabel     ? OFFER_SCORE_CONFIG.traceablePart.yes     : 0,
      recentTestReport: trace.isRecentTraceReport ? OFFER_SCORE_CONFIG.recentTestReport.yes : 0,
      avlVendor:      this.formModel?.isAvlVendor ? OFFER_SCORE_CONFIG.avlVendorBonus        : 0,
    };

    const score            = Object.values(breakdown).reduce((sum, v) => sum + v, 0);
    const testingDecisionId = this.resolveTestingDecision(score);

    this.offerScoreResult = {
      score,
      maxScore: OFFER_SCORE_CONFIG.maxScore,
      testingDecisionId,
      breakdown,
    };

    // Sync back to formModel so submission always has the latest values
    this.formModel.offerScore        = score.toString();
    this.formModel.testingDecisionId = testingDecisionId;

    // Rebuild tooltip from live breakdown
    this.tooltipContent = this.buildTooltip(breakdown);
  }

  /** Returns score for the selected label, defaults to 0 if not found. */
  private getLabelScore(labelId: string | null | undefined): number {
    if (!labelId) return 0;
    return OFFER_SCORE_CONFIG.label[labelId] ?? 0;
  }

  /** Returns score for the selected trace document, defaults to 0. */
  private getTraceDocScore(traceDoc: string | null | undefined): number {
    if (!traceDoc) return 0;
    return OFFER_SCORE_CONFIG.traceDocument[traceDoc] ?? 0;
  }

  /** Walks thresholds top-to-bottom and returns the first matching testingDecisionId. */
  private resolveTestingDecision(score: number): string {
    for (const threshold of TESTING_DECISION_THRESHOLDS) {
      if (score >= threshold.minScore) return threshold.testingId;
    }
    return '1'; // fallback: Required
  }

  /** Builds the tooltip string from a breakdown object. */
  private buildTooltip(breakdown: OfferScoreResult['breakdown']): string {
    return [
      `Label: ${breakdown.label}`,
      `Trace Doc: ${breakdown.traceDocument}`,
      `Traceable Part: ${breakdown.traceablePart}`,
      `Test Report: ${breakdown.recentTestReport}`,
      `AVL Vendor (Bonus): ${breakdown.avlVendor}`,
      `Testing: Optional`,
    ].join('\n');
  }

  // ── Dropdown / data fetching ────────────────────────────────────────────────
  getDropdownData(): void {
    this.partsListService.allPartDropdownList().subscribe((res) => {
      if (res.isSuccess) {
        this.getAllDropdown = res.response;
        this.allContactList = res.response.vendorContactList;
        this.viewOffersDetails();
      }
    });
  }

  getAllMasterDropdownList(): void {
    this.commonTabService.getAllDropDownList().subscribe({
      next: (res: any) => {
        this.testingDecisionList = res.response.testingDecisionList;
      },
    });
  }

  viewOffersDetails(): void {
    if (this.data.clone) {
      this.formModel = { ...this.formModel, ...this.data.formModel };
      this.formModel.offerDetails = { ...new OfferDetailsModel(), ...this.data.formModel?.offerDetails };
      this.formModel.dateOfOffer = this.formModel.dateOfOffer
        ? this.stringToDateService.convertStringToDate(this.formModel.dateOfOffer)
        : this.getCurrentDateAsNgbDate();
      setTimeout(() => {
        this.markDropdownItemsAsActive();
        this.recalculateScore(); // ← sync score after clone data is applied
      });
    }

    if (this.data.alternateOffer) {
      this.formModel.offerDetails.mpnId = this.getAllDropdown?.mpnList
        .find((val: any) => val.name?.toString().trim().toLowerCase() === (this.data.mpn || this.data.partNumber)?.toString().trim().toLowerCase())?.id;
      this.formModel.offerDetails.mfrId = this.getAllDropdown?.masterManufacturerWithChildrenList
        .find((val: any) => val.name?.toString().trim().toLowerCase() === (this.data.mfrName || this.data.mfr)?.toString().trim().toLowerCase())?.id;
      this.formModel = {
        ...this.formModel,
        dateOfOffer: this.formModel.dateOfOffer ? this.stringToDateService.convertStringToDate(this.formModel.dateOfOffer) : this.getCurrentDateAsNgbDate(),
        vendorId:    this.data.vendorId,
        contactId:   this.data.contactId,
      };
      if (!this.formModel.contactId) {
        this.getContactList(this.formModel.vendorId);
      }
    }

    if (!this.data.viewOffer && !this.data.offerForRFQ && !this.data.alternateOffer) return;

    switch (this.title) {
      case 'View Offer':
        this.partsListService.getViewOfferDetailsById(this.data?.id).subscribe((res) => {
          if (res?.isSuccess) {
            this.formModel = { ...this.formModel, ...res.response };
            this.formModel.offerDetails = { ...new OfferDetailsModel(), ...res.response?.offerDetails };
            this.formModel.dateOfOffer = this.formModel.dateOfOffer ? this.stringToDateService.convertStringToDate(this.formModel.dateOfOffer) : this.getCurrentDateAsNgbDate();
            this.formModel.offerDetails.mpnId = this.data?.mpnId;
            this.formModel.offerDetails.mfrId = this.data?.mfrId;
            this.markDropdownItemsAsActive();
            this.recalculateScore(); // ← sync after view data is loaded

            if (this.formModel.contactId) {
              this.disabledContact = true;
            } else {
              this.getContactList(this.formModel.vendorId);
              this.disabledContact = false;
            }
          }
        });
        break;

      case 'Add Offer for RFQ':
        this.offerForRFQ = this.data.offerForRFQ;
        this.formModel.offerDetails.mpnId = this.getAllDropdown?.mpnList
          .find((val: any) => val.name?.toString().trim().toLowerCase() === (this.data.mpn || this.data.partNumber)?.toString().trim().toLowerCase())?.id;
        this.formModel.offerDetails.mfrId = this.getAllDropdown?.masterManufacturerWithChildrenList
          .find((val: any) => val.name?.toString().trim().toLowerCase() === (this.data.mfrName || this.data.mfr)?.toString().trim().toLowerCase())?.id;
        this.formModel = {
          ...this.formModel,
          dateOfOffer: this.formModel.dateOfOffer ? this.stringToDateService.convertStringToDate(this.formModel.dateOfOffer) : this.getCurrentDateAsNgbDate(),
          vendorId:    this.data.vendorId,
          contactId:   this.data.contactId,
        };
        if (this.data.contactId) {
          this.disabledContact = true;
        } else {
          this.getContactList(this.data.vendorId);
          this.disabledContact = false;
        }
        break;
    }
  }

  // ── Event handlers ──────────────────────────────────────────────────────────
  onLabelChange(event: any): void {
    this.formModel.traceDetails.labelId = event;
    this.recalculateScore();
  }

  onTraceDocumentChange(event: any): void {
    this.formModel.traceDetails.traceDocument = event;
    this.recalculateScore();
  }

  onRadioChange(item: any, isChecked: boolean, activeState: number): void {
    switch (activeState) {
      case 1:
        this.labelList.forEach((l) => (l.status = false));
        this.formModel.traceDetails.labelId = item?.id;
        break;
      case 2:
        this.formModel.traceDetails.isTraceableLabel = item?.value;
        break;
      case 3:
        this.formModel.traceDetails.isTraceableLabel = item?.value;
        break;
      case 4:
        this.formModel.traceDetails.isRecentTraceReport = item?.value;
        break;
    }
    item.status = isChecked;
    this.recalculateScore(); // single call covers all radio cases
  }

  onKeydown(event: any, value: any): void {
    const element = this.renderer.selectRootElement(value, true);
    if (event.key === 'Enter') element.focus();
  }

  activeTab(id: number): void {
    this.active = id;
  }

  onVendorChange(vendorId: string): void {
    this.formModel.vendorId = vendorId;
    this.getContactList(vendorId);
    this.disabledContact = !vendorId;
    this.recalculateScore();
  }

  // ── Form submission ─────────────────────────────────────────────────────────
  prepareFormModel(): any {
    // Score is already synced via recalculateScore() — just convert the date
    this.formModel.dateOfOffer = this.formModel.dateOfOffer
      ? this.stringToDateService.dateConvertedToString(this.formModel.dateOfOffer)
      : this.getCurrentDateAsString();
    return { ...this.formModel };
  }

  addOffer(): void {
     this.submit = true;
    if (!this.checkRequiredField() || this.title === 'View Offer') {
      return;
    }
    const requestModel = this.prepareFormModel();
    this.partsListService.addOffers(requestModel).subscribe((res) => {
      if (res?.isSuccess) {
        this.toaster.success(res?.message);
        this.activeModal.close({ response: res, confirm: true });
      }
    });
  }

  onClickUpdate(): void {
    const requestModel = this.prepareFormModel();
    this.partsListService.updateOffers(requestModel).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          this.toaster.success(res?.message);
          this.activeModal.close({ response: res, update: true });
        }
      },
      error: (err) => console.error(err),
    });
  }

  checkRequiredField(): boolean {
    return !!(
      this.formModel?.dateOfOffer &&
      this.formModel?.vendorId &&
      this.formModel?.qtyOffered &&
      this.formModel?.cost &&
      this.formModel?.currency &&
      this.formModel?.testingDecisionId &&
      this.formModel?.offerDetails?.mpnId &&
      this.formModel?.offerDetails?.mfrId &&
      this.formModel?.offerDetails?.dateCodeYearId &&
      this.formModel?.offerDetails?.dateCodeWeekId &&
      this.formModel?.offerDetails?.rohsId?.length &&
      this.formModel?.offerDetails?.itemPackagingId &&
      this.formModel?.offerDetails?.cooId?.length &&
      this.formModel?.offerDetails?.vendorLeadTime &&
      this.formModel?.offerDetails?.warranty &&
      this.formModel?.traceDetails?.labelId
    );
  }

  // ── Date helpers ────────────────────────────────────────────────────────────
  getCurrentDateAsNgbDate(): any {
    const today = new Date();
    const dateString = `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
    return this.stringToDateService.convertStringToDate(dateString);
  }

  getCurrentDateAsString(): string {
    const today = new Date();
    return `${today.getMonth() + 1}/${today.getDate()}/${today.getFullYear()}`;
  }

  // ── Dropdown helpers ────────────────────────────────────────────────────────
  markDropdownItemsAsActive(): void {
    if (this.getAllDropdown?.countryList && this.formModel?.offerDetails?.cooId) {
      const selectedCooIds = Array.isArray(this.formModel.offerDetails.cooId)
        ? this.formModel.offerDetails.cooId.map((item: any) => (typeof item === 'object' ? item.id : item))
        : [this.formModel.offerDetails.cooId];

      this.getAllDropdown.countryList = this.getAllDropdown.countryList.map((item: any) => ({
        ...item,
        isActive: selectedCooIds.includes(item.id),
      }));
      this.formModel.offerDetails.cooId = this.getAllDropdown.countryList
        .filter((item: any) => item.isActive)
        .map((item: any) => item.name);
      this.getAllDropdown = { ...this.getAllDropdown, countryList: [...this.getAllDropdown.countryList] };
    }

    if (this.getAllDropdown?.roHSList && this.formModel?.offerDetails?.rohsId) {
      const selectedRohsIds = Array.isArray(this.formModel.offerDetails.rohsId)
        ? this.formModel.offerDetails.rohsId.map((item: any) => (typeof item === 'object' ? item.id : item))
        : [this.formModel.offerDetails.rohsId];

      this.getAllDropdown.roHSList = this.getAllDropdown.roHSList.map((item: any) => ({
        ...item,
        isActive: selectedRohsIds.includes(item.id),
      }));
      this.formModel.offerDetails.rohsId = this.getAllDropdown.roHSList
        .filter((item: any) => item.isActive)
        .map((item: any) => item.name);
      this.getAllDropdown = { ...this.getAllDropdown, roHSList: [...this.getAllDropdown.roHSList] };
    }
  }

  getContactList(id: string): void {
    this.disabledContact = !id;
    this.selectedVendorId = id;
    if (!id) {
      this.formModel.contactId = '';
      this.getAllDropdown.vendorContactList = this.allContactList;
      return;
    }
    this.activityTabService.getContactList(id).subscribe((res) => {
      if (res.isSuccess) {
        this.getAllDropdown.vendorContactList = res.response.contactList;
        this.formModel.contactId = this.getAllDropdown.vendorContactList?.[0]?.id || '';
      }
    });
  }

  onMpnGetbyId(id: string): void {
    if (id) {
      this.partsListService.getPartInventoryById(id).subscribe((res) => {
        if (res?.isSuccess) {
          this.formModel.offerDetails.description  = res.response.description;
          this.formModel.partsDetails.spq          = res.response.spq;
        }
      });
    }
  }

  // ── Category cascade helpers ────────────────────────────────────────────────
  onChangedValue(event: any, label: string): void {
    if (event === '') {
      this.clearFields(label, event);
    } else if (event) {
      this.clearFields(label, '');
      this.fetchById(label, event);
    }
  }

  clearFields(label: string, value: any): void {
    const model = this.formModel.partsDetails;
    switch (label) {
      case LabelsName.CATEGORY_GROUP:
        model.parentCategoryId = model.categoryId = model.subCategoryId = value;
        break;
      case LabelsName.PARENT_CATEGORY:
        model.categoryId = model.subCategoryId = value;
        break;
      case LabelsName.CATEGORY:
        model.subCategoryId = value;
        break;
    }
  }

  fetchById(label: string, event: any): void {
    const ids: Record<string, any> = {
      [LabelsName.CATEGORY_GROUP]:   Categories.CATEGORY_GROUPID,
      [LabelsName.PARENT_CATEGORY]:  Categories.PARENT_CATEGORY_GROUPID,
      [LabelsName.CATEGORY]:         Categories.CATEGORY_ID,
    };
    this.getById(ids[label], event, label);
  }

  getById(request: any, id: any, label: string): void {
    this.partsListService.getInventoryCategoryDropdownById(request, id).subscribe((res) => {
      if (res) {
        switch (label) {
          case LabelsName.CATEGORY_GROUP:
            this.getAllDropdown.parentCategoryGroupList = res.response.list;
            break;
          case LabelsName.PARENT_CATEGORY:
            this.getAllDropdown.inventoryCategoryList = res.response.list;
            break;
          case LabelsName.CATEGORY:
            this.getAllDropdown.subCategoryList = res.response.list;
            break;
        }
      }
    });
  }

  // ── Multi-select emitters ───────────────────────────────────────────────────
  inputValueEmit(event: any): void {
    if (!this.getAllDropdown?.roHSList) return;
    this.getAllDropdown.roHSList = this.getAllDropdown.roHSList.map((item: any) =>
      item.id === event.id ? { ...item, isActive: event.isActive } : item
    );
    this.formModel.offerDetails = this.formModel.offerDetails ?? {};
    this.formModel.offerDetails.rohsId = this.getAllDropdown.roHSList.filter((a: any) => a.isActive) ?? [];
  }

  inputValueCOOEmit(event: any): void {
    if (!this.getAllDropdown?.countryList) return;
    this.getAllDropdown.countryList = this.getAllDropdown.countryList.map((item: any) =>
      item.id === event.id ? { ...item, isActive: event.isActive } : item
    );
    this.formModel.offerDetails = this.formModel.offerDetails ?? {};
    this.formModel.offerDetails.cooId = this.getAllDropdown.countryList.filter((a: any) => a.isActive) ?? [];
  }

  // ── Modal launchers ─────────────────────────────────────────────────────────
  openAddContactModal(): void {
    const modalOption: NgbModalOptions = {
      centered: true, backdrop: 'static', keyboard: false, windowClass: 'addContactPopup',
    };
    const modalRef = this.modalService.open(AddContactComponent, modalOption);
    modalRef.componentInstance.insertConatactModel.companyId = this.selectedVendorId;
    modalRef.componentInstance.isComapny      = false;
    modalRef.componentInstance.disabledVendor = true;

    modalRef.result.then((res) => {
      if (res.isSuccess) {
        const contactdata = res.response.response.id;
        this.activityTabService.getContactList(this.selectedVendorId).subscribe((contactRes: any) => {
          if (contactRes.isSuccess) {
            this.getAllDropdown.vendorContactList = contactRes.response.contactList;
            this.formModel.contactId = contactdata;
          }
        });
        this.agGridService.setPaginationData(this.paginationBaseModel);
      }
    });
  }

  openAddVendorPopup(): void {
    const modalOption: NgbModalOptions = {
      centered: true, backdrop: 'static', keyboard: false, windowClass: 'addCompanyPopUP',
    };
    const modalRef = this.modalService.open(AddCompanyComponent, modalOption);
    modalRef.componentInstance.headingsNames = 'Add Vendor';
    modalRef.componentInstance.editName      = 'Edit Vendor';

    modalRef.result.then((res) => {
      if (res.isSuccess) {
        const newdata   = res.response.response.generalInfo;
        const vendorId  = newdata.id;
        this.formModel.vendorId = vendorId;

        this.commonTabService.getAllDropDownList().subscribe(masterRes => {
          if (masterRes.isSuccess) {
            this.commonTabService.getAllDropdownList.next(masterRes.response);
          }
        });

        this.partsListService.allPartDropdownList().subscribe((resp) => {
          if (resp.isSuccess) {
            this.getAllDropdown = resp.response;
            this.allContactList = resp.response.vendorContactList;
            this.viewOffersDetails();
            this.activityTabService.getContactList(vendorId).subscribe((contactRes: any) => {
              if (contactRes.isSuccess) {
                this.getAllDropdown.vendorContactList = contactRes.response.contactList;
                this.formModel.contactId  = this.getAllDropdown.vendorContactList?.[0]?.id;
                this.disabledContact      = false;
                this.selectedVendorId     = vendorId;
              }
            });
          }
        });
      }
    });
  }

  openAddEditPartModal(): void {
    this.sendDataService
      .openModalPopup(AddEditPartComponent, {}, 'Add Part', ModalPopupSize.LG, 'add-part-popup')
      .then((resultData) => {
        if (resultData?.confirm) {
          if (resultData?.response) {
            const partData = resultData.response.response;
            this.formModel.offerDetails.mpnId = partData.id;
            this.formModel.offerDetails.mfrId = partData.manufacturerId;
          }
          this.getDropdownData();
        }
      });
  }

  openAddEditMFRModal(): void {
    this.sendDataService
      .openModalPopup(AddEditManufacturerComponent, {}, 'Add', ModalPopupSize.MD, 'has-parent-popup')
      .then((resultData) => {
        if (resultData?.isSuccess) {
          if (resultData?.response) {
            this.formModel.offerDetails.mfrId = resultData.response.response.id;
          }
          this.getDropdownData();
        }
      });
  }

  selectMpnMfrValueChange(event: any, source: 'mpn' | 'mfr'): void {
    if (event === '') {
      this.disabledMPNfields = false;
      this.formModel.offerDetails = new OfferDetailsModel();
      return;
    }
    if (source === 'mpn') {
      this.formModel.offerDetails.mpnId = event;
      const data = this.getAllDropdown.mpnList.find((x: any) => x.id === event);
      if (data?.extra1) {
        this.formModel.offerDetails.mfrId = data.extra1;
      }
      this.partDetailsGetById();
    } else if (source === 'mfr') {
      this.formModel.offerDetails.mfrId = event;
    }
  }

  partDetailsGetById(): void {
    this.formModel.partsDetails = new RequirementParts();
    this.partsListService.getPartDetailById(this.formModel.offerDetails.mpnId).subscribe({
      next: (res) => {
        if (res.isSuccess && res.response) {
          this.partDetails = res.response ?? {};
          const compliance = this.partDetails.complianceExportModel;
          this.formModel.offerDetails.mpnId            = this.partDetails.id;
          this.formModel.offerDetails.mfrId            = this.partDetails.manufacturerId;
          this.formModel.partsDetails.categoryGroupId  = compliance?.categoryGroupId;
          this.formModel.partsDetails.parentCategoryId = compliance?.parentCategoryId;
          this.formModel.partsDetails.categoryId       = compliance?.categoryId;
          this.formModel.partsDetails.subCategoryId    = compliance?.subCategoryId;
          this.formModel.partsDetails.spq              = this.partDetails.spq;
          this.formModel.partsDetails.moq              = this.partDetails.moq;
          this.formModel.partsDetails.hts              = compliance?.hts;
          this.formModel.partsDetails.scheduleB        = compliance?.schedB;
          this.formModel.partsDetails.eccn             = compliance?.eccn;
          this.formModel.partsDetails.tempRange        = this.partDetails.tempGradeName;
          this.formModel.partsDetails.partStatus       = this.partDetails.partStatusId;
        }
      },
    });
  }
}